import * as $ from "jquery";
import imkt from '../../../imkt';

imkt.software.ProductBundle = class {
  $domRoot: HTMLElement;
  params: {};
  $baseCta: JQuery<HTMLElement>;
  $priceHeading: JQuery<HTMLElement>;
  baseCtaHref: any;
  basePrice: number;

  constructor(domRoot: HTMLElement, params: {}) {
    this.$domRoot = domRoot || $("body");

    this.params = { ...params };
    this.$baseCta = $(".column--result-price").find(".button");
    this.$priceHeading = $(".price-disclaimer h2 .initial-price");

    this.baseCtaHref = this.$baseCta.attr("href");
    this.basePrice = parseInt(this.$priceHeading.text().replace("$", ""), 10);

    this.init();
  }

  init() {
    this.bindEvents();
  }
  
  bindEvents() {
    var self = this;

    this.$domRoot
      .on("click", ".column--bundle", function () {
        // On a bundle column click => trigger cta click
        var buttonCta = $(this).find(".button").last();
        var locationUrl = buttonCta.attr("href");

        if (locationUrl) {
          window.location = locationUrl;
        }
      })
      .on("change", ".column--bundle-product input", function () {
        self.checkAddons();
      });

    $(document).ready(function () {
      self.checkAddons();
    });
  }

  checkAddons() {
    // Add or remove the bundle param to the cta button with the correct bundle url
    var $ctaLink = this.$baseCta;
    var currentCtaHref = this.baseCtaHref;
    var currentPrice = this.basePrice;

    $(".column--bundle-product input[type='checkbox']").each(function () {
      var $input = $(this);
      var addOnParam = "," + $input.attr("name");
      var addOnPrice = parseInt($input.data("custom"), 10);
      var thisIndex =
        $(this).closest(".column--bundle-product").find("input").index(this) +
        1;

      if ($input.is(":checked")) {
        $(".column--result-price li").eq(thisIndex).addClass("active");
        currentPrice += addOnPrice;
        currentCtaHref = currentCtaHref + addOnParam;
      } else {
        $(".column--result-price li").eq(thisIndex).removeClass("active");
      }
    });
    $ctaLink.attr("href", currentCtaHref);
    this.updatePrice(currentPrice);
  }

  updatePrice(price: string) {
    this.$priceHeading.html("<sup>$</sup>" + price);
  }
}

// Use document.ready since we are initializing ourselves
$(function () {
  if (!imkt.isEditMode) {
    new imkt.software.ProductBundle();
  }
});
